import { Controller } from "stimulus";

// Keeps the submit button's label and state in step with the toggles: the label's wording comes from the server
// (labels value), and a locked, subscribed or pending row is never counted because its input is disabled.
export default class extends Controller {
  static targets = ["checkbox", "button", "label"];
  static values = { labels: Object };

  connect() {
    this.update();
  }

  update() {
    const count = this.checkboxTargets.filter((box) => box.checked && !box.disabled).length;
    const { none, one, many } = this.labelsValue;
    this.labelTarget.textContent = count === 0 ? none : count === 1 ? one : many.replace("%{count}", count);
    this.buttonTarget.disabled = count === 0;
  }
}
